import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import blackChevron from '../../../images/black-chevron-right.svg';

// * Wrapper for the accordion (Menu item that drops down)
export const Accordion = styled.div`
  float: left;

  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    position: relative;
    margin: 0 15px;
    height: 100%;
  }

  @media only screen and (max-width: ${themeGet('breakpoints.ml')}) {
    width: 100%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 0 25px;
  }
`;

// * Button that opens / closes the accordion
export const AccordionBtn = styled.button`
  font-family: ${themeGet('fonts.primary')};
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.24px;
  line-height: 21px;
  text-align: left;
  width: 100%;
  border-bottom: 0.5px solid #95a1ad;

  padding: 20px 0;
  margin-top: 15px;

  /* position: relative; */

  display: flex;
  align-items: center;
  justify-content: space-between;

  &::after {
    content: '';
    background-image: url(${blackChevron});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    transform: rotate(90deg);
    width: 16px;
    height: 12px;
  }

  ${Accordion}.is-open & {
    border-bottom: 4px solid ${themeGet('colors.orange')};

    &::after {
      transform: rotate(-90deg);
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    position: relative;
    height: 100%;

    border-bottom: none;
    padding: 0;
    margin-top: 0;

    &::before {
      content: '';
      position: absolute;
      /* bottom: -6px; */
      bottom: 0;
      display: block;
      width: 100%;
      height: 0%;
      max-height: 3px;
      background-color: ${themeGet('colors.orange')};
      transition: height 300ms;
    }

    &::after {
      margin-left: 10px;
    }

    &:hover,
    &:focus {
      &::before {
        height: 100%;
      }
    }

    ${Accordion}.is-open & {
      border-bottom: none;

      &::before {
        height: 100%;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

// * Styled div that wraps all the content for the body of the accordion
export const AccordionBody = styled.div`
  display: none;
  opacity: 0;

  padding: 8px 0 18px;

  ${Accordion}.is-open & {
    display: block;
    opacity: 1;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    padding: 0;

    background-color: ${themeGet('colors.white')};
    position: absolute;
    z-index: 1001;
    min-width: 13.75em;
    text-align: left;
    background-clip: padding-box;
    transition: opacity 300ms;
    /* top: calc(100% + 6px); */
    top: 100%;
    width: auto;

    right: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    right: auto;
  }
`;

// * Div that wraps the list item that slides out (Similar to accordion)
export const SlideOutWrapper = styled.div`
  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    display: block;
    background-color: #ffffff;
    padding: 0.5em 0.625em;
    border-radius: 4px;
    border: 1px solid #d2d5d9;
    border-radius: 2px;

    transition: height 300ms;

    width: 100%;
    padding-left: 0;
    padding-right: 0;
    transition: width 300ms;
    transition-delay: 100ms;
    overflow: hidden;

    padding: 15px 0;

    height: ${({ height }) => height};

    &.is-open {
      width: 200%;
      transition-delay: 0ms;

      &::after {
        position: absolute;
        content: '';
        display: block;
        width: 1px;
        border-left: 1px solid #7d8894;
        left: auto;
        right: 1px;
        top: 15px;
        height: calc(100% - 30px);
        z-index: 25;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

// * The UI that contains all the slideouts
export const SlideOutList = styled.ul`
  li {
    line-height: 1;
    position: relative;

    &::after {
      content: '';
      pointer-events: none;
      position: absolute;
      bottom: 0;
      display: block;
      height: 100%;
      border-bottom: 0.5px solid #e6ecef;
      width: calc(100% - 25px);
      margin-left: 25px;
    }
  }

  > li {
    &:first-child {
      border-bottom: none;
      a,
      button {
        /* padding: 0px 0 18px; */
      }

      &::after {
        width: calc(50% - 25px);
        margin-bottom: 4px;
      }
    }
  }

  a,
  button {
    display: flex;
    text-decoration: none;
    border-bottom: none;

    width: 100%;
    padding: 15px 0 15px 25px;
    position: relative;

    text-align: left;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.19px;
    line-height: 16px;

    &:hover,
    &:focus {
      background-color: #e6ecef;
      color: ${themeGet('colors.black')};
      text-decoration: none;
      border-bottom: none;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    width: 15.625em;
    position: relative;
    z-index: 1;
    border-right: 0.5px solid;
    min-height: 0;
    transition: border-color 300ms, min-height 300ms;
    border-right-color: transparent;

    li {
      line-height: 1;
      border: none;
      position: static;

      &::after {
        content: none;
      }
    }

    > li {
      &:first-child {
        position: relative;

        a,
        button {
          padding: 11px 15px 7px;
        }

        &::after {
          content: '';
          display: block;
          height: 0.5px;
          width: 80%;
          margin: 0 15px;
          border-bottom: 0.5px solid #7d8894;
        }
      }
    }

    a,
    button {
      display: flex;
      text-decoration: none;
      border-bottom: none;

      text-align: left;
      font-size: 15px;
      font-weight: 600;
      letter-spacing: -0.2px;
      line-height: 18px;
      width: 100%;
      padding: 11px 15px;
      position: relative;

      &:hover,
      &:focus {
        background-color: #e6ecef;
        color: ${themeGet('colors.black')};
        text-decoration: none;
        border-bottom: none;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;
